var $0872a642b1e91721$exports = {};
/*
TPI - https://vimeo.com/1158215889?fl=ip&fe=ec -> https://player.vimeo.com/video/1158215889

Unsung Heroes - https://vimeo.com/1154069665?fl=ip&fe=ec

Christmas Village - https://vimeo.com/1154067049?fl=ip&fe=ec

2025 Mayor’s Masked Ball - https://vimeo.com/1154065478?fl=ip&fe=ec

2025 Ayla Awards - https://vimeo.com/1154064401?fl=ip&fe=ec

*/ const $0872a642b1e91721$var$embedParams = "&title=0&byline=0&portrait=0";
const $0872a642b1e91721$var$sourceMap = {
    tpi: `https://player.vimeo.com/video/1158215889?autoplay=1${$0872a642b1e91721$var$embedParams}`,
    unsung: `https://player.vimeo.com/video/1154069665?autoplay=1${$0872a642b1e91721$var$embedParams}`,
    christmas: `https://player.vimeo.com/video/1154067049?autoplay=1${$0872a642b1e91721$var$embedParams}`,
    masked: `https://player.vimeo.com/video/1154065478?autoplay=1${$0872a642b1e91721$var$embedParams}`,
    ayla: `https://player.vimeo.com/video/1154064401?autoplay=1${$0872a642b1e91721$var$embedParams}`
};
function $0872a642b1e91721$var$isKeyofSourceMap(key) {
    return !!key && key in $0872a642b1e91721$var$sourceMap;
}
const $0872a642b1e91721$var$buttons = document.querySelectorAll("button");
$0872a642b1e91721$var$buttons.forEach((button)=>{
    button.addEventListener("click", (event)=>{
        const key = event.currentTarget.dataset.videoKey;
        if ($0872a642b1e91721$var$isKeyofSourceMap(key)) $0872a642b1e91721$var$replaceVideo($0872a642b1e91721$var$sourceMap[key]);
    });
});
function $0872a642b1e91721$var$replaceVideo(nextSource) {
    const iframe = document.querySelector("iframe");
    iframe.src = nextSource;
}


//# sourceMappingURL=video.d104af62.js.map
